import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BasemodelService } from 'src/app/basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class GmDashboardService {
  private token2 = "";
  constructor(public http: HttpClient, private base: BasemodelService) { }
  getcampusdashboard() {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token2,
      'Content-Type': 'application/json'
    })
    return this.http.get(this.base.getcctv()+ "/ses/cctv/gmCampusDetails", { headers })
  }
  campusdashboard(emp: any) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token2,
      'Content-Type': 'application/json'
    })
    return this.http.get(this.base.getCommonUrl()+ "/apiV2/empCampusesByPayroll?employee=" + emp, { headers })

  }
  getbuildingdashboard(id: any) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token2,
      'Content-Type': 'application/json'
    })
    return this.http.get(this.base.getcctv()+ "/ses/cctv/gmBuildingDetails?campusId=" + id, { headers })

  }

  getemployeesdashboard() {
    const headers = new HttpHeaders({
      'Authorization': this.token2,
      'Content-Type': 'application/json'
    })
    console.log(this.base.getcctv())
    return this.http.get(this.base.getcctv() + "/ses/cctv/AllEmployees", { headers })
  }
  getemployesssearch(searchterm: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token2,
      'Content-Type': 'application/json'
    })
    return this.http.get(this.base.getcounsellingURL() + "/jwtV2/api/common/empSearchByPayroll?payrollId=" + searchterm, { headers })

    //  return this .http.get("https://testwebservice.scaits.net/jwtV2/api/common/empSearchByPayroll?payrollId=HYD310809",{headers})
  }
  getemployecamera(empid: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token2,
      'Content-Type': 'application/json'
    })
    return this.http.get(this.base.getcctv() + "/ses/cctv/EmployeeDvrsAndCameras?empId=" + empid, { headers })
  }
  getempyoleaddcamera(buildingId: any, empId: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token2,
      'Content-Type': 'application/json'
    })
    return this.http.get(this.base.getcctv() + "/ses/cctv/EmployeeBuildingDvrsAndCameras?buildingId=" + buildingId + "&empId=" + empId, { headers })
  }
  getChannel(cctvDetId: any, channelId: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token2,
      'Content-Type': 'application/json'
    })
    return this.http.get<any>(this.base.getcctv() + "/ses/cctv/dvrDetails?cctvDetId=" + cctvDetId + "&channelsNo=" + channelId, { headers })
  }
  getsavecammera(data: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token2,
      'Content-Type': 'application/json'
    })
    return this.http.post(this.base.getcctv() + "/ses/cctv/saveGmDashboardDetails", data, { headers });
  }
  getdelectedcamera(dvrId: any) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token2,
      'Content-Type': 'application/json'
    })
    return this.http.get(this.base.getcctv() + "/ses/cctv/deleteCamera?dvrChannelId=" + dvrId, { headers })
  }
  gettotaldvr() {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token2,
      'Content-Type': 'application/json'
    })
    return this.http.get<any>(this.base.getcctv() + "/ses/cctv/overallDvrDetails", { headers })
  }

  saveDraggedcammera(data: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token2,
      'Content-Type': 'application/json'
    })
    return this.http.post(this.base.getcctv() + "/ses/cctv/saveGmDashboardDetailsList", data, { headers });
  }
   getimage(payrolled:any):Observable<Blob>{
        const headers = new HttpHeaders({
         'Authorization': this.token2,
         'Content-Type': 'application/json'
       })
       return this.http.get(this.base.getCommonUrl()+"/employee/api/jwtV2/userId/profileImage?payrollId="+payrolled,{headers,responseType: 'blob'})
     }
}


